import http from 'hub-http/clients/apiClient';
import { lruMemoizeAsyncExceptInTests } from '../utils/memoize';
export const getFormUsedByInteractiveId = lruMemoizeAsyncExceptInTests(async interactiveId => {
  const results = await http.get('cosindex/api/v1/connections/children', {
    query: {
      id: interactiveId,
      childType: 'FORM'
    }
  });
  return results.map(({
    model
  }) => model);
});
export const getCtaLocations = lruMemoizeAsyncExceptInTests(interactiveId => http.get('cosindex/api/v1/connections/parents', {
  query: {
    id: interactiveId,
    parentType: 'CONTENT'
  }
}).then(result => {
  const locations = result[interactiveId] || [];
  return locations.map(({
    id,
    label,
    model
  }) => ({
    id: Number.parseInt(id, 10),
    name: label,
    categoryId: model.categoryId,
    subcategory: model.subcategory
  }));
}));